<template>
  <div class="componentBox">
    <h2 class="componentTitle">客户信息</h2>
    <Cell :colList="list" :detail="detail" />
  </div>
</template>

<script>
import Cell from './Cell.vue';
export default {
  components: {Cell},
  props: ['detail'],
  data() {
    return {
      list: [
        {title: '客户姓名',field: 'customerName',},
        {title: '客户电话',field: 'customerPhone',},
        {title: '省市区/县',field: 'area',},
        {title: '详细地址',field: 'address',},
        // {title: '猪场类型',field: 'farmType',},
        // {title: '猪场性质',field: 'farmNature',},
        // {title: '饲养模式',field: 'feedModel',},
        {title: '规模（头）',field: 'farmScale',},
        // {title: '栏舍类型',field: 'fenceType',},
        // {title: '地板类型',field: 'floorType',},
        // {title: '粪水处理',field: 'shitHandle',},
        {title: '所属工厂',field: 'factoryName',},
        {title: '聚落/片区',field: 'settlementName',},
      ],
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>